export const SET_INSTALLATIONS_HEADERS = 'SET_INSTALLATIONS_HEADERS';
export const SET_INSTALLATIONS_ROWS = 'SET_INSTALLATIONS_ROWS';
